// src\components\ProductionView.jsx
import React from 'react';
import ResponsiveDashboard from './dashboard/ResponsiveDashboard';
import { useData } from '../contexts/DataContext';

const ProductionView = () => {
  const { loading, error } = useData();

  // Si les données sont en cours de chargement
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Si une erreur s'est produite
  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded">
          <p className="font-bold">Erreur</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // Utiliser le composant dashboard responsive qui détecte automatiquement 
  // le type d'appareil et adapte l'affichage
  return <ResponsiveDashboard />;
};

export default ProductionView;